import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { ConverterService, OccEndpointsService } from '@spartacus/core';
import { Observable } from 'rxjs';
import { filter, map, switchMap, take, tap } from 'rxjs/operators';
import { UigAddToWishlistComponent } from '../uig-product/uig-add-to-wishlist/uig-add-to-wishlist.component';
import { UigCartModification } from './uig-cart.models';
import { UigCartService } from './uig-cart.service';
import {OccCartEntryAdapter} from '@spartacus/cart/base/occ';
import {CartEntryAdapter, MultiCartSelectors, StateWithMultiCart} from '@spartacus/cart/base/core';
import {WishListService} from '@spartacus/cart/wish-list/core';
import {CART_MODIFICATION_NORMALIZER, CartType} from '@spartacus/cart/base/root';


@Injectable({
  providedIn: 'root'
})
export class UigOccCartEntryAdapter extends OccCartEntryAdapter implements CartEntryAdapter {

  wishListId: string;

  constructor(
    protected http: HttpClient,
    protected occEndpointsService: OccEndpointsService,
    protected converterService: ConverterService,
    protected uigCartService: UigCartService,
    protected wishListService: WishListService,
    protected store: Store<StateWithMultiCart>,
    private uigAddToWishlistComponent: UigAddToWishlistComponent,
  ) {
    super(http, occEndpointsService, converterService);
    this.store.pipe(select(MultiCartSelectors.getCartIdByTypeFactory(CartType.WISH_LIST))).pipe(
      map((wishListId) =>
        {
          this.wishListId = wishListId;
        }
      )
    ).subscribe();
  }

  public add(
    userId: string,
    cartId: string,
    productCode: string,
    quantity: number = 1
  ): Observable<UigCartModification> {
    const url = this.occEndpointsService.buildUrl('addEntries', {
      urlParams: { userId, cartId, quantity },
    });

    // Handle b2b case where the x-www-form-urlencoded is still used
    if (url.includes(`quantity=${quantity}`)) {
      const headers = new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded',
      });

      return this.http
        .post<UigCartModification>(
          url,
          {},
          { headers, params: { code: productCode } }
        )
        .pipe(
          tap((cartModification) => {
            if (cartId != this.wishListId && cartModification == null)
            {
              this.uigCartService.setIsRemovedEntry(true);
            }
            else {
              if (cartId == this.wishListId && ((cartModification && cartModification.notListed == true) || cartModification == null))
              {
                this.uigAddToWishlistComponent.errorHandler(false, productCode);
              }
              else if (cartId != this.wishListId && cartModification != null && cartModification.notListed !== undefined) {
                this.uigCartService.setLastEntryListedStatus(!cartModification.notListed);
              }
            }
          }),
          this.converterService.pipeable(CART_MODIFICATION_NORMALIZER),
        );
    }

    const toAdd = {
      quantity,
      product: { code: productCode },
    };

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });

    return this.http
      .post<UigCartModification>(url, toAdd, { headers })
      .pipe(
        tap((cartModification) => {
          if (cartId != this.wishListId && cartModification == null)
          {
            this.uigCartService.setIsRemovedEntry(true);
          }
          else {
            if (cartId == this.wishListId && ((cartModification && cartModification.notListed == true) || cartModification == null))
            {
              this.uigAddToWishlistComponent.errorHandler(false, productCode);
            }
            else if (cartId != this.wishListId && cartModification != null && cartModification.notListed !== undefined) {
              this.uigCartService.setLastEntryListedStatus(!cartModification.notListed);
            }
          }
        }),
        this.converterService.pipeable(CART_MODIFICATION_NORMALIZER),
      );
  }

  public update(
    userId: string,
    cartId: string,
    entryNumber: string,
    qty: number,
    pickupStore?: string
  ): Observable<UigCartModification> {
    let params = {};
    if (pickupStore) {
      params = {
        deliveryPointOfService: {
          name: pickupStore,
        },
      };
    }

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });

    const url = this.occEndpointsService.buildUrl('updateEntries', {
      urlParams: {
        userId,
        cartId,
        entryNumber,
      },
    });

    return this.http
      .patch<UigCartModification>(url, { quantity: qty, ...params }, { headers })
      .pipe(
        tap((cartModification) => {
          if (cartModification == null) {
            this.uigCartService.setIsRemovedEntry(true);
          }
          else {
            if (cartModification.notListed !== undefined) {
              this.uigCartService.setLastEntryListedStatus(!cartModification.notListed);
            }
          }
        }),
        this.converterService.pipeable(CART_MODIFICATION_NORMALIZER)
      );
  }

  public remove(
    userId: string,
    cartId: string,
    entryNumber: string
  ): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
    });

    const url = this.occEndpointsService.buildUrl('removeEntries', {
      urlParams: {
        userId,
        cartId,
        entryNumber,
      },
    });

    return this.http.delete(url, { headers });
  }
}
